import { connect } from 'react-redux';
import { ApplicationState } from '../../../../store';
import PreCasInterviewPage1, { IProps } from './index';
import { getPageStatus } from './utils';

const mapStateToProps = (state: ApplicationState): IProps => {
  const defaultValues = {
    whyUk: '',
    whyUkOther: '',
    selectedCourseReasons: [],
    selectedCourseReasonsOther: '',
    selectedUniReasons: [],
    selectedUniReasonsOther: '',
    uniChoiceReason1: '',
    uniChoiceReason2: '',
    uniChoiceReason3: '',
  };

  const {
    whyUk,
    whyUkOther,
    selectedCourseReasons,
    selectedCourseReasonsOther,
    selectedUniReasons,
    selectedUniReasonsOther,
    uniChoiceReason1,
    uniChoiceReason2,
    uniChoiceReason3,
  } = { ...defaultValues, ...state.student.preCasInterview };

  const { complete } = getPageStatus({
    whyUk,
    whyUkOther,
    selectedCourseReasons,
    selectedCourseReasonsOther,
    selectedUniReasons,
    selectedUniReasonsOther,
    uniChoiceReason1,
    uniChoiceReason2,
    uniChoiceReason3,
  });

  return {
    complete,
    currentStep: 1,
    steps: 4,
    whyUk,
    whyUkOther,
    selectedCourseReasons,
    selectedCourseReasonsOther,
    selectedUniReasons,
    selectedUniReasonsOther,
    uniChoiceReason1,
    uniChoiceReason2,
    uniChoiceReason3,
    pageConfig: state.student.config.Interview.Page1,
  };
};

export default connect(mapStateToProps)(PreCasInterviewPage1);
